import { Box, Collapse, Flex, Text, Tooltip, VStack } from '@televet/kibble-ui';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { RouteBasePaths, SettingsRoutes } from 'routes';
import { useModularity } from 'shared/hooks/useModularity';

const RecapProUpgradeBanner = ({ isCollapsed }: { isCollapsed: boolean }): JSX.Element | null => {
  const { isSubscriptionActive, isRecapTrialSubscription, recapTrialRemainingDays } = useModularity();

  const [showText, setShowText] = useState(isCollapsed);
  useEffect(() => {
    if (isCollapsed) {
      setShowText(false);
    } else {
      setTimeout(() => {
        setShowText(true);
      }, 400);
    }
  }, [isCollapsed]);

  const history = useHistory();

  const remainingDaysText = useMemo(() => {
    if (recapTrialRemainingDays === 0) {
      return 'Your free trial has ended';
    }
    return `You have ${recapTrialRemainingDays} ${
      recapTrialRemainingDays === 1 ? 'day' : 'days'
    } left of your free trial`;
  }, [recapTrialRemainingDays]);

  if (!isRecapTrialSubscription) {
    return null;
  }

  return (
    <Tooltip label={!showText ? remainingDaysText : ''} placement="top-end">
      <VStack
        align="flex-start"
        spacing={2}
        py={2}
        px={3}
        borderRadius="md"
        bg="linear-gradient(85deg, #E9F2FF 0%, #FFDFE6 100%)"
        overflow="hidden"
        cursor="pointer"
        onClick={(): void => history.push(`${RouteBasePaths.Settings}${SettingsRoutes.ClinicSubscription}`)}
      >
        <Flex gap={isCollapsed ? 0 : 1} w="100%" justify={isCollapsed ? 'center' : 'flex-start'}>
          <Box flex="0 1 auto" overflow="hidden" whiteSpace="nowrap">
            <Text as="p" fontWeight="bold">
              {isSubscriptionActive ? 'Trial in progress' : 'Trial ended'}
            </Text>
          </Box>

          <Box flex="0 0 auto">
            <Text>🚀</Text>
          </Box>
        </Flex>
        <Collapse in={showText}>
          <Text as="p">{remainingDaysText}</Text>
        </Collapse>
      </VStack>
    </Tooltip>
  );
};

export default RecapProUpgradeBanner;
